<template>
    <div>
        <div class="flex justify-between">
            <div class="w-[35%]">
                <label>From</label>
            </div>
            <div class="w-[35%]">
                <label>To</label>
            </div>
            <div class="w-[30%]"></div>
        </div>
        <validation-observer tag="div"
                             ref="input-range"
                             class="flex justify-between mb-2">
            <div class="w-[35%]">
                <validation-provider v-slot="{ classes }"
                                     :rules="validateRulesFrom"
                                     mode="passive"
                                     class="w-full"
                                     name="From"
                                     tag="div">
                    <div class="form-group mb-0" :class="[classes]">
                        <input v-model.trim="form.from"
                               :min="Number(config.min)"
                               :minlength="config.minlength"
                               :max="Number(config.max) - 1"
                               :maxlength="config.maxlength"
                               :type="config.type"
                               class="form-control rounded-tr-none rounded-br-none shadow-none"/>
                    </div>
                </validation-provider>
            </div>
            <div class="w-[35%]">
                <validation-provider v-slot="{ classes }"
                                     :rules="validateRulesTo"
                                     vid="compare-to"
                                     class="w-full"
                                     mode="passive"
                                     name="To"
                                     tag="div">
                    <div class="form-group mb-0" :class="[classes]">
                        <input v-model.trim="form.to"
                               :min="Number(config.min) + 1"
                               :minlength="config.minlength"
                               :max="Number(config.max)"
                               :maxlength="config.maxlength"
                               :type="config.type"
                               class="form-control rounded-none border-r-0 border-l-0 shadow-none"/>
                    </div>
                </validation-provider>
            </div>
            <div class="w-[30%]">
                <button
                    @click="addRange"
                    class="btn btn-blue bg-fully w-full h-[46px] rounded-tl-none rounded-bl-none uppercase">
                    Add
                </button>
            </div>
        </validation-observer>
    </div>
</template>

<script>
    import { EventBus } from "@widget/plugins/event-bus";
    import { ValidationObserver, ValidationProvider } from "vee-validate";

    require("@widget/utils/validation-rules");

    export default {
        name: "input-range",
        props: {
            item: {
                type: Object,
                require: true,
                default: () => {
                    return {};
                }
            }
        },
        components: {
            ValidationObserver,
            ValidationProvider
        },
        computed: {
            config () {
                return this.item.config ? this.item.config : this.item.widget_config;
            },
            validateRulesFrom () {
                let rules = "required|compare-from-to:@compare-to";
                if (this.config.hasOwnProperty("min")) {
                    rules += `|min_value:${Number(this.config.min)}`;
                }
                if (this.config.hasOwnProperty("max")) {
                    rules += `|max_value:${Number(this.config.max) - 1}`;
                }
                if (this.config.hasOwnProperty("minlength")) {
                    rules += `|min:${this.config.minlength}`;
                }
                if (this.config.hasOwnProperty("maxlength")) {
                    rules += `|max:${this.config.maxlength}`;
                }
                return rules;
            },
            validateRulesTo () {
                let rules = "required";
                if (this.config.hasOwnProperty("min")) {
                    rules += `|min_value:${Number(this.config.min) + 1}`;
                }
                if (this.config.hasOwnProperty("max")) {
                    rules += `|max_value:${Number(this.config.max)}`;
                }
                if (this.config.hasOwnProperty("minlength")) {
                    rules += `|min:${this.config.minlength}`;
                }
                if (this.config.hasOwnProperty("maxlength")) {
                    rules += `|max:${this.config.maxlength}`;
                }
                return rules;
            },
            checkSelectStore () {
                let selectStore = this.$store.getters["widgetData/getSelectByCode"](this.item.code);
                return !!(selectStore &&
                    Number(selectStore.query[0]) === Number(this.form.from) &&
                    Number(selectStore.query[1]) === Number(this.form.to));

            }
        },
        methods: {
            addRange () {
                this.$refs["input-range"].validate().then(async success => {
                    if (success && !this.checkSelectStore) {
                        let sensitive = this.item.attentionText !== "";

                        if (sensitive) {
                            sensitive = this.item.code === "b2c_age" && (Number(this.form.from) >= 65);
                        }

                        this.$store.commit("widgetData/addSelect", {
                            sensitive,
                            code: this.item.code,
                            group: this.item.group,
                            title: `${this.item.title}: ${Number(this.form.from)} - ${Number(this.form.to)}`,
                            query: [Number(this.form.from), Number(this.form.to)]
                        });
                    }
                });
            },
            loadFromStorage () {
                let storeSelect = this.$store.getters["widgetData/getSelectByCode"](this.item.code);
                if (storeSelect) {
                    this.form.from = Number(storeSelect.query[0]);
                    this.form.to = Number(storeSelect.query[1]);

                    this.$emit("open");
                } else {
                    if (this.config.hasOwnProperty("min")) {
                        this.form.from = Number(this.config.min);
                    }
                    if (this.config.hasOwnProperty("max")) {
                        this.form.to = Number(this.config.max);
                    }
                }
            }
        },
        mounted () {
            EventBus.$on("load-local-storage", () => {
                this.loadFromStorage();
            });

            EventBus.$on("remove-select", code => {
                if (code === this.item.code) {
                    if (this.config.hasOwnProperty("min")) {
                        this.form.from = Number(this.config.min);
                    }
                    if (this.config.hasOwnProperty("max")) {
                        this.form.to = Number(this.config.max);
                    }

                    this.$emit("close");
                }
            });

            EventBus.$on("clear-all", () => {
                if (this.config.hasOwnProperty("min")) {
                    this.form.from = Number(this.config.min);
                }
                if (this.config.hasOwnProperty("max")) {
                    this.form.to = Number(this.config.max);
                }

                this.$emit("close");
            });

            this.loadFromStorage();
        },
        data () {
            return {
                form: {
                    from: null,
                    to: null
                },
                serverErrors: null
            };
        }
    };
</script>
